import { format, formatDistanceToNow, parseISO } from "date-fns";
import { toZonedTime, format as fmtTz } from "date-fns-tz";
import { ro } from "date-fns/locale";

// App-wide timezone constant (matches backend core/timezone_ro.py)
export const APP_TZ = "Europe/Bucharest";

function _parse(iso) {
  if (!iso) return null;
  try { return typeof iso === "string" ? parseISO(iso) : new Date(iso); } catch { return null; }
}

// Convert any timestamp to a Date in Europe/Bucharest local-wall-clock representation
function _local(iso) {
  const d = _parse(iso);
  if (!d || isNaN(d.getTime())) return null;
  return toZonedTime(d, APP_TZ);
}

export function fmtDate(iso) {
  const d = _local(iso);
  if (!d) return "—";
  try { return format(d, "d MMM yyyy, HH:mm", { locale: ro }); } catch { return String(iso); }
}

export function fmtRelative(iso) {
  const d = _parse(iso);
  if (!d) return "—";
  try { return formatDistanceToNow(d, { addSuffix: true, locale: ro }); } catch { return String(iso); }
}

export function fmtShort(iso) {
  const d = _local(iso);
  if (!d) return "—";
  try { return format(d, "d MMM", { locale: ro }); } catch { return String(iso); }
}

// Explicit timezone-aware formatter (e.g. "20 Mai 2026, 23:45 EET")
export function fmtDateTz(iso, pattern = "d MMM yyyy, HH:mm") {
  const d = _parse(iso);
  if (!d) return "—";
  try { return fmtTz(d, pattern, { timeZone: APP_TZ, locale: ro }); } catch { return String(iso); }
}

// Returns today's date in YYYY-MM-DD format using Europe/Bucharest.
// Used by date inputs (e.g. AdSpendDialog default).
export function todayInRO() {
  return fmtTz(new Date(), "yyyy-MM-dd", { timeZone: APP_TZ });
}

export const PRIORITY_LABELS = {
  low: "Scăzută",
  medium: "Medie",
  high: "Ridicată",
  urgent: "Urgentă",
};

export const RETURN_TYPE_LABELS = {
  refund: "Rambursare",
  exchange: "Schimb",
  voucher: "Voucher",
};
